// The template builder's catalog-team reads (#602), shared with the Templates gallery (#1121): one query key per
// read, so a team the builder dressed is already cached when the gallery draws its card after Save, and the other
// way round when the operator opens Edit.
import { prepacksApi } from '@/services/api'

/** How long a dressed preview team is fresh: a logo flag or icon rarely changes while Studio runs. */
export const PREVIEW_TEAM_STALE_MS = 10 * 60 * 1000

// A stable select keeps react-query's result, and the picker's groups, the same object between renders.
export const selectTeams = (data) => (Array.isArray(data?.teams) ? data.teams : [])

/** Every catalog team (GET .../prepacks/templates/teams, #602), one list per organization, kept for the session. */
export function templateTeamsQuery(orgSlug) {
  return {
    queryKey: ['prepacks', 'template-teams', orgSlug],
    queryFn: ({ signal }) => prepacksApi.fetchTemplateTeams(orgSlug, { signal }),
    enabled: Boolean(orgSlug),
    // The list is built once from the catalog embedded in the server: it never changes while Studio runs.
    staleTime: Infinity,
    retry: 1,
    select: selectTeams,
  }
}

/** One catalog team dressed as a leg carries it (GET .../prepacks/templates/preview-team?team=, #602); '' is the server's default Eagles. */
export function templatePreviewTeamQuery(orgSlug, teamId = '') {
  return {
    queryKey: ['prepacks', 'template-preview-team', orgSlug, teamId],
    queryFn: ({ signal }) => prepacksApi.fetchTemplatePreviewTeam(orgSlug, teamId ? { signal, team: teamId } : { signal }),
    enabled: Boolean(orgSlug),
    staleTime: PREVIEW_TEAM_STALE_MS,
    retry: false,
  }
}
